import { z } from 'zod';

export type UpdateAssignmentPayload = z.output<typeof updateAssignmentPayloadSchema>;
export type UpdateAssignmentPayloadDTO = z.input<typeof updateAssignmentPayloadSchema>;

export const updateAssignmentPayloadSchema = z.object({
  ignored: z.boolean().optional(),
  playerId: z.uuid().nullable().optional(),
});
